import React, { Suspense, useEffect, useState } from 'react';
import { Outlet, useMatches } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import PageLoadingFallback from '../shared/PageLoadingFallback';
import { useAcademy } from '../../hooks/useAcademy';
import { StagesProvider } from '../../contexts/StagesContext';
import { HelpCentreProvider } from '../../contexts/HelpCentreContext';

function BrandingApplicator() {
  const { academy } = useAcademy();

  useEffect(() => {
    const root = document.documentElement;
    const primary = academy?.branding?.primaryColor;
    if (primary) {
      root.style.setProperty('--accent', primary);
      root.style.setProperty('--accent-light', `color-mix(in srgb, ${primary} 12%, white)`);
    } else {
      root.style.removeProperty('--accent');
      root.style.removeProperty('--accent-light');
    }
    return () => {
      root.style.removeProperty('--accent');
      root.style.removeProperty('--accent-light');
    };
  }, [academy?.branding?.primaryColor]);

  return null;
}

export default function PageShell() {
  const matches = useMatches();
  const title = matches.at(-1)?.handle?.title ?? '';
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <StagesProvider>
      <HelpCentreProvider>
      <div className="app-shell flex h-screen overflow-hidden">
        <BrandingApplicator />
        {mobileOpen && (
          <div
            className="fixed inset-0 z-40 bg-black/50 md:hidden"
            onClick={() => setMobileOpen(false)}
          />
        )}
        <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
        <div className="flex flex-col flex-1 overflow-hidden" style={{ background: 'var(--bg)' }}>
          <Topbar title={title} onMenuClick={() => setMobileOpen(true)} />
          <main className="app-main flex-1 overflow-y-auto p-4 md:py-7 md:px-8">
            <Suspense fallback={<PageLoadingFallback />}>
              <Outlet />
            </Suspense>
          </main>
        </div>
      </div>
      </HelpCentreProvider>
    </StagesProvider>
  );
}
